import { bl_fi_jrnl_hdr_RowClass } from '../../../dbschema/bl_fi_jrnl_hdr.model';
import { bl_fi_jrnl_line_RowClass } from '../../../dbschema/bl_fi_jrnl_line.model';
import {BaseContainerModel} from '../../base-container.model';


export class JournalContainerModel extends BaseContainerModel {
  bl_fi_jrnl_hdr: bl_fi_jrnl_hdr_RowClass = new bl_fi_jrnl_hdr_RowClass();
  bl_fi_jrnl_lines: bl_fi_jrnl_line_RowClass[] = [];
}
